module.exports = {
  newsVal: 'Latest News',
  moreVal: 'Watch More',
  partnerVal: 'Partners',
  placeVal: 'Broadcasting Platform',
  placePhoneVal: 'Platform',
  areaVal: 'Countries and Regions',
  areaPhoneVal: 'Country',
  cateVal: 'Category',
  yearVal: 'Year',
  queryVal: 'Query',
  modelInputVal: 'Model Search',
  chineseVal: 'China',
  outVal: 'Abroad',
  adviceVal: 'Advice',
  aboutVal: 'About us',
  contactVal: 'Contact us',
  declareVal: 'Copyright',
  privateVal: 'Private',
  companyVal: '沪公网安备:31010602005167',
  recordVal: '备案号:沪ICP备14027572号-2',
  allVal: 'All',
  reportVal: 'Report',
  tvBoChuVal: 'TV platform',
  itemVal: 'PTY',
  bochuDateVal: 'Premiere date',
  totalItemsVal: 'Total seasons',
  totalNumVal: 'Total number',
  itemLongVal: 'Program duration',
  reportTimeVal: 'Airtime',
  reportPartVal: 'Broadcast period',
  targetPeoVal: 'audience age group',
  peoVal: 'Host',
  companyDoVal: 'Production house',
  webShowVal: 'Preview website',
  itemItroduceVal: 'Program introduction',
  visionVal: 'Audience performance',
  judgeItemVal: 'Comment on program mode',
  itemPicVal: 'Program pictures and flowers',
  commitVal: 'Comments',
  detailVal: 'Detail',
  inputSayVal: 'Say Something...',
  indexVal: 'IndexPage',
  modelList: 'Model List',
  modelReport: 'Model Report',
  modelSearch: 'Model institute',
  registe: 'regist',
  nextStep: 'next',
  hasAccount: 'has account',
  loginNow: 'Log in now',
  welcome: 'welcome',
  mailVal: 'Please enter email',

  phoneVal: 'Please enter phone',
  userVal: 'Please enter user',
  passwordVal: 'Please enter password',
  companVal: 'Please enter company',
  leaderVal: 'Please enter position',
  readBefore: 'Read ',
  readOld: ' and ',
  readTip: 'Read copyright notice and notice protection',
  readTipNew: 'copyright notice',
  readTipSec: 'notice protection',
  loginVal: 'log in',
  welcomeBack: 'welcome back',
  userEnter: 'Please enter user',
  passwordEnter: 'Please enter password',
  noAccount: 'no Account',
  registNow: 'regist now',
  hellow: 'peple Message',
  confirmMsg: 'Please Confirm',
  confirmBtn: 'Confirm',
  downLoad: 'DownLoad',
  allSearch: 'please Enter',
  commentList: 'Comments',
  yearReport: 'year',
  monthReport: 'month',
  weekReport: 'week'
}
